export const Layout = {
  pixelsPerTick: 0.1,
  keyHeight: 16,
  keyWidth: 64,
  blackKeyWidthRatio: 0.64,
  rulerHeight: 32,
  drumKeysWidth: 128,
}

export const MaxNoteNumber = 127

export const WHEEL_SCROLL_RATE = 1 / 120

export const DEFAULT_TEMPO = 120
